import type { SxProps, Theme } from "~/common/mui";

export const salesPartnerMobileDetailsModalSx: SxProps<Theme> = (theme) => ({
  "&.scha__sp__mobile-details .scha__modal__contents": {
    height: "100%",
    paddingInline: theme.spacing(2),
  },
  "&.scha__sp__mobile-details .scha__modal__contents__children": {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  "& .scha__sp__mobile-details__data": {
    paddingBottom: theme.spacing(2),
  },
  "& .scha__sp__mobile-details__action": {
    width: "100vw",
    position: "relative",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    marginBottom: theme.spacing(-2),
    flexGrow: 1,
    padding: theme.spacing(2),
    background: theme.palette.surface.main,
  },
  "& .scha__sp__mobile-details__action__login": {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
  },
  "& .scha__sp__mobile-details__show-map": {
    marginBottom: theme.spacing(2),
  },
});
